export default __webpack_public_path__ + "static/media/640_dummy2016-sportbekleidung01-mobile-de.fdc5880c.png";